import React from "react";
import SecurityIcon from "@material-ui/icons/Security";

function AgenturaIcon(props) {
  return <SecurityIcon {...props}/>;
}

export default AgenturaIcon;
